import { orgUser } from "../../../common";

// --

export const fields: Record<keyof orgUser.IOrgUser, keyof orgUser.IOrgUser> = {
	ouOrgId: "ouOrgId",
	ouUserId: "ouUserId",
	ouRole: "ouRole",
	ouType: "ouType",
	ouUseSeat: "ouUseSeat",
	ouUseSeatAgreement: "ouUseSeatAgreement",
	ouLastLogin: "ouLastLogin",
	ouCreatedAt: "ouCreatedAt",
	ouUpdatedAt: "ouUpdatedAt",
};

export const role: Record<orgUser.TRole, orgUser.Role> = {
	usaer: 0,
	facilitator: 10,
	designer: 100,
	admin: 1000,
	owner: 10000,
};

export const roleDict: Record<orgUser.Role, string> = {
	0: "user",
	10: "Facilitator",
	100: "Designer",
	1000: "Admin",
	10000: "Owner",
};

export const type: Record<orgUser.TType, orgUser.Type> = {
	member: 0,
	guest: 1,
};

export const typeDict: Record<orgUser.Type, string> = {
	0: "member",
	1: "guest",
};
